<!--
title:面包屑名称
type: 1:蓝色背景，0白色背景
path: 面包屑链接需要加'/'
 -->
<template>
  <!-- 面包屑导航 -->
  <div class="breadcrumb">
    <div style="display: flex">
      <div>
        <img
          src="../assets/icon/icon_shangyibu.png"
          v-if="isback == '0'"
          style="width: 16px; height: 16px"
        />
      </div>
      <div class="back" @click="back" v-if="isback == '0'">返回上一级</div>
      <!-- <div class="backFirst" v-else>返回上一级</div> -->
      <div class="line" v-if="isback == '0'"></div>
      <el-breadcrumb separator="/" style="margin-top: 4px">
        <el-breadcrumb-item
          :to="{ path: item.path }"
          v-for="(item, index) in breadcrumbConfig.list"
          :key="index"
        >
          {{ item.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
  <!-- 面包屑导航 -->
</template>
<script>
export default {
  name: 'breadcrumb',
  props: {
    breadcrumbConfig: {
      type: Object,
      default: () => { }
    },
    isBack: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      isback: '0',
    }
  },
  watch: {
    isBack: {
      handler (newVal, oldVal) {
        console.log(newVal)
        // this.isback = newVal
      },
      deep: true,
    }
  },
  created () {
    this.isback = String(this.isBack)
    console.log(this.isback)
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumb {
  margin-top: 0px;
  .back {
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #2d46ee;
    opacity: 1;
    cursor: pointer;
  }
  .backFirst {
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #2d46ee;
    opacity: 1;
  }
  .line {
    width: 1px;
    height: 16px;
    background: #c0c0cc;
    opacity: 1;
    border-radius: 0px;
    margin-left: 12px;
    margin-right: 12px;
    margin-top: 2px;
  }
}
::v-deep .el-breadcrumb__separator {
  // margin-left: 7px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  // color: #303033;
}
.border {
  margin-left: 5px;
}
/* 不被选中时的颜色 */
.el-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #909099 !important;
  font-weight: 400 !important;
}
/* 被选中时的颜色 */
.el-breadcrumb__item:last-child ::v-deep .el-breadcrumb__inner {
  color: #2d46ee !important;
  font-weight: 400 !important;
}
</style>
